export default __webpack_public_path__ + "static/media/7.6192a48d.jpg";